import classnames from 'classnames';
import PropTypes from 'prop-types';
import IconTool from '../IconTool';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ExpandableLabelHeader = function ExpandableLabelHeader(_ref) {
  var className = _ref.className,
      expanded = _ref.expanded,
      onExpand = _ref.onExpand,
      roundedCorners = _ref.roundedCorners,
      children = _ref.children,
      wholeInteractive = _ref.wholeInteractive;
  var classes = classnames("ptr-ExpandableLabelHeader ".concat(className || ''), {
    'is-expanded': expanded,
    'is-rounded': roundedCorners,
    'is-interactive': wholeInteractive
  });

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      onExpand(!expanded);
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    onClick: wholeInteractive ? function () {
      return onExpand(!expanded);
    } : function () {},
    onKeyDown: wholeInteractive ? handleKeyDown : function () {},
    tabIndex: wholeInteractive ? 0 : -1,
    children: [/*#__PURE__*/_jsx("div", {
      className: "ptr-ExpandableLabelHeader-content",
      children: children
    }), /*#__PURE__*/_jsx(IconTool, {
      tooltip: {
        text: 'Layer tools',
        position: 'right',
        id: 'ExpendableLayerLabel'
      },
      active: expanded,
      onClick: function onClick() {
        return onExpand(!expanded);
      },
      icon: "ri-chevron-down",
      rectangular: !roundedCorners,
      small: true,
      className: "ptr-ExpandableLabelHeader-controlButton"
    })]
  });
};
ExpandableLabelHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  expanded: PropTypes.bool,
  roundedCorners: PropTypes.bool,
  onExpand: PropTypes.func,
  wholeInteractive: PropTypes.bool
};
export default ExpandableLabelHeader;